export const DYNAMIC_IMPORT_CASE_NAME_HEADER = 'Case name';
export const DYNAMIC_IMPORT_CASE_STATUS_HEADER = 'Case status';
export const DYNAMIC_IMPORT_ORIGINAL_CASE_ID_HEADER = 'Original case ID';
export const DYNAMIC_IMPORT_ORIGINAL_INTAKE_METHOD_HEADER =
  'Original intake method';
export const DYNAMIC_IMPORT_CREATED_DATE_HEADER = 'Created date';
export const DYNAMIC_IMPORT_CLOSED_DATE_HEADER = 'Closed date';
export const DYNAMIC_IMPORT_SUBMISSION_DATE_HEADER = 'Submission date';
export const DYNAMIC_IMPORT_INVESTIGATING_DATE_HEADER = 'Investigating date';
export const DYNAMIC_IMPORT_CASE_LEAD_EID_HEADER = 'Case lead EID';
export const DYNAMIC_IMPORT_CASE_LEAD_EMAIL_HEADER = 'Case lead email';
export const DYNAMIC_IMPORT_CASE_LEAD_NAME_HEADER = 'Case lead name';
export const DYNAMIC_IMPORT_SUBSTANTIATION_STATUS_HEADER =
  'Substantiation status';
export const DYNAMIC_IMPORT_REPORTER_ANONYMOUS_HEADER = 'Reporter Anonymous';
export const DYNAMIC_IMPORT_REPORTER_EID_HEADER = 'Reporter EID';
export const DYNAMIC_IMPORT_REPORTER_EMAIL_HEADER = 'Reporter email';
export const DYNAMIC_IMPORT_REPORTER_NAME_HEADER = 'Reporter name';
export const DYNAMIC_IMPORT_CASE_COUNTRY_HEADER = 'Case country';
export const DYNAMIC_IMPORT_CASE_REGION_HEADER = 'Case region';
export const DYNAMIC_IMPORT_CASE_SUMMARY_HEADER = 'Case summary';

type FormQuestion = {
  orderIndex?: number | null;
  questionText?: string | null;
};

export const buildDynamicCsvTemplateHeaders = (
  questions: FormQuestion[] | null | undefined,
): string[] => {
  const questionHeaders = [...(questions ?? [])]
    .sort((a, b) => (a.orderIndex ?? 0) - (b.orderIndex ?? 0))
    .map((question) => question.questionText?.trim())
    .filter((questionText): questionText is string => Boolean(questionText));

  return [
    ...questionHeaders,
    DYNAMIC_IMPORT_CASE_NAME_HEADER,
    DYNAMIC_IMPORT_CASE_STATUS_HEADER,
    DYNAMIC_IMPORT_ORIGINAL_CASE_ID_HEADER,
    DYNAMIC_IMPORT_ORIGINAL_INTAKE_METHOD_HEADER,
    DYNAMIC_IMPORT_CREATED_DATE_HEADER,
    DYNAMIC_IMPORT_CLOSED_DATE_HEADER,
    DYNAMIC_IMPORT_SUBMISSION_DATE_HEADER,
    DYNAMIC_IMPORT_INVESTIGATING_DATE_HEADER,
    DYNAMIC_IMPORT_CASE_LEAD_EID_HEADER,
    DYNAMIC_IMPORT_CASE_LEAD_EMAIL_HEADER,
    DYNAMIC_IMPORT_CASE_LEAD_NAME_HEADER,
    DYNAMIC_IMPORT_SUBSTANTIATION_STATUS_HEADER,
    DYNAMIC_IMPORT_REPORTER_ANONYMOUS_HEADER,
    DYNAMIC_IMPORT_REPORTER_EID_HEADER,
    DYNAMIC_IMPORT_REPORTER_EMAIL_HEADER,
    DYNAMIC_IMPORT_REPORTER_NAME_HEADER,
    DYNAMIC_IMPORT_CASE_COUNTRY_HEADER,
    DYNAMIC_IMPORT_CASE_REGION_HEADER,
    DYNAMIC_IMPORT_CASE_SUMMARY_HEADER,
  ];
};
